// asset imports
import "@/assets/scss/soft-ui-dashboard.scss";

export default {};
